import { forwardRef, type ReactNode } from "react";
import { cn } from "@/lib/utils";

export interface LogoStripItem {
  name: string;
  /** Optional render override; when omitted, the bare name is shown in font-display. */
  render?: ReactNode;
}

export interface LogoStripProps {
  items: LogoStripItem[];
  label?: ReactNode;
  className?: string;
}

export const LogoStrip = forwardRef<HTMLDivElement, LogoStripProps>(function LogoStrip(
  { items, label, className },
  ref,
) {
  return (
    <div ref={ref} className={cn("flex flex-col items-center gap-6", className)}>
      {label && <span className="dateline">{label}</span>}
      <ul className="flex flex-wrap items-center justify-center gap-x-10 gap-y-6 opacity-60">
        {items.map((it) => (
          <li key={it.name} className="text-display text-lg tracking-tight text-foreground">
            {it.render ?? it.name}
          </li>
        ))}
      </ul>
    </div>
  );
});
